import React from 'react';
import { LabelList } from '.';
import { QueueUxPreferences, Opinion, OpinionCategoryLabels } from 'services';
import { IBasePicker, ITag } from '@fluentui/react';
import { SidebarTagPicker } from 'components/layout';

interface LabelSelectionProps {
  onComponentChange(opinion: Opinion): void;
  onTraitSelection?(trait: string[]): void;
  selectedTrait?: string[];
  labelsData: OpinionCategoryLabels;
  focusRef: React.RefObject<IBasePicker<ITag>>;
  uxPreferences: QueueUxPreferences;
  isDisabled: boolean;
  renderTraitDefinitions?: boolean;
}

interface LabelSelectionState {
  searchDisabled: boolean;
  selectionActive: boolean;
  checkboxActive: boolean;
  currentOpinion: Opinion;
  currentSearchText: string;
}

export class LabelSelection extends React.PureComponent<LabelSelectionProps, LabelSelectionState> {
  private labelsDataKeys: string[];

  constructor(props) {
    super(props);
    this.state = {
      searchDisabled: false,
      selectionActive: false,
      checkboxActive: false,
      currentSearchText: '',
      currentOpinion: new Opinion()
    };

    // Sorting categories
    this.labelsDataKeys = Object.keys(this.props.labelsData).sort();
  }

  render(): JSX.Element {
    if (this.labelsDataKeys.length === 1 && this.props.labelsData[this.labelsDataKeys[0]].length <= 5) {
      return (
        <div>
          <LabelList
            opinion={this.state.currentOpinion}
            disabled={this.state.selectionActive || this.props.isDisabled}
            labelsData={this.props.labelsData[this.labelsDataKeys[0]]}
            onClick={(e): void => this.onListClick(e)}
          />
        </div>
      );
    } else {
      // Sorting Subcategories
      const labelsData: {
        [id: string]: string[];
      } = {};
      this.labelsDataKeys.forEach(key => {
        labelsData[key] = this.props.labelsData[key].sort();
      });
      if (this.props.selectedTrait && this.props.selectedTrait.length > 0) {
        return (
          <SidebarTagPicker
            focusRef={this.props.focusRef}
            labelsData={labelsData}
            uxPreferences={this.props.uxPreferences}
            onComponentChange={this.props.onComponentChange}
            onTraitSelection={this.props.onTraitSelection}
            selectedTrait={this.props.selectedTrait}
            isPickerDisabled={this.props.isDisabled}
            renderTraitDefinitions={this.props.renderTraitDefinitions}
          />
        );
      } else {
        return (
          <SidebarTagPicker
            focusRef={this.props.focusRef}
            labelsData={labelsData}
            uxPreferences={this.props.uxPreferences}
            onComponentChange={this.props.onComponentChange}
            onTraitSelection={this.props.onTraitSelection}
            isPickerDisabled={this.props.isDisabled}
            renderTraitDefinitions={this.props.renderTraitDefinitions}
          />
        );
      }
    }
  }

  private onListClick(listSelection: string): void {
    // Selecting and Removing label
    const opinionObj = Object.assign({}, this.state.currentOpinion);
    const categoryKey = this.labelsDataKeys[0];

    let indexOfLabel = -1;

    if (opinionObj.opinionCategoryLabels[this.labelsDataKeys[0]] == null) {
      opinionObj.opinionCategoryLabels[this.labelsDataKeys[0]] = [];
    }

    const currentLabels = this.state.currentOpinion.opinionCategoryLabels[categoryKey];
    indexOfLabel = currentLabels.indexOf(listSelection);

    if (indexOfLabel >= 0) {
      // Removing label
      opinionObj.opinionCategoryLabels[categoryKey] = currentLabels.filter(label => label !== listSelection);
    } else {
      opinionObj.opinionCategoryLabels[categoryKey].push(listSelection);
    }

    this.props.onComponentChange(opinionObj);

    this.setState({
      currentOpinion: opinionObj
    });
  }
}
